<template>
    <v-row
        v-if="coupons.length"
        no-gutters
        class="px-10 pt-5 pb-7 b-bottom-outlined"
    >
        <v-col
            cols="12"
            class="subtitle-1 font-weight-bold pb-5"
            v-text="translations.coupons[lang]"
        ></v-col>

        <v-col v-for="coupon in coupons" :key="coupon.coupon_id" cols="4">
            <div
                class="b-coupon"
                v-text="makeTextShorter(coupon.gift_title)"
                :title="coupon.gift_title"
                @click="
                    () => {
                        claimingCoupon = {
                            code: coupon.code,
                            name: coupon.gift_title
                        };
                        dialog = true;
                    }
                "
            ></div>
        </v-col>

        <v-dialog v-model="dialog" max-width="500">
            <b-card
                :title="translations.dialogTitle[lang]"
                :loading="loading"
                :error-message="errorMessage"
                :submit-text="{ el: 'Ναι', en: 'Yes', it: 'Si' }"
                @cancel="dialog = false"
                @submit="getVerificationCode(claimingCoupon.code)"
            >
                <div class="subtitle-1 font-weight-medium pl-2">
                    {{ translations.dialogDescription[lang] }}
                    <span class="font-weight-bold text--primary">{{
                        claimingCoupon.name
                    }}</span>
                    {{ translations.dialogDescription2[lang] }}
                </div>
            </b-card>
        </v-dialog>

        <v-dialog v-model="redeemDialog" max-width="500" eager>
            <b-card
                :title="translations.verificationCode[lang]"
                :loading="loading"
                :error-message="errorMessage"
                :timer="validationCountDown"
                :submit-text="{
                    el: 'Επιβεβαίωση',
                    en: 'Verify',
                    it: 'Verifica'
                }"
                @cancel="redeemDialog = false"
                @submit="submitVerificationCode()"
            >
                <div class="subtitle-1 font-weight-medium pl-2 mb-4">
                    {{ translations.verificationCodeDescription[lang] }}
                </div>
                <div class="d-flex flex-row">
                    <div
                        v-for="(char, i) in verificationCodeAr"
                        :key="i"
                        class="subtitle-1 font-weight-medium pl-2"
                    >
                        <v-text-field
                            solo
                            height="100"
                            class="verification-input"
                            :ref="'codeChar' + i"
                            @keyup="setCodeChar(char, i)"
                            v-model="verificationCodeAr[i]"
                            :autofocus="i === 0"
                            :rules="verificationCodeRules"
                            validate-on-blur
                        ></v-text-field>
                    </div>
                </div>
            </b-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import translations from "@/utils/translations/storePanel/newTransaction/coupons";

export default {
    name: "Coupons",
    mixins: [translations],

    data: () => ({
        claimingCoupon: {
            code: null,
            name: ""
        },
        dialog: false,
        redeemDialog: false,
        verificationCodeAr: ["", "", "", ""],
        verificationCodeRules: [],
        validationTime: null
    }),

    computed: {
        ...mapState(["loading", "errorMessage"]),
        ...mapState("storePanel/transactions", [
            "coupons",
            "transaction",
            "couponVerification"
        ]),

        lang() {
            return this.$route.params.lang;
        },

        transaction: {
            get() {
                return this.$store.state.storePanel.transactions.transaction;
            },

            set(val) {
                this.setItem(val);
            }
        },

        validationCountDown: {
            get() {
                if (!this.validationTime) return "";
                let minutes = Math.floor(this.validationTime / 60);
                let seconds = this.validationTime - minutes * 60;
                return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
            }
        }
    },

    methods: {
        ...mapMutations(["setDialog", "setNotification"]),
        ...mapMutations("storePanel/transactions", [
            "setCouponVerification",
            "setItem",
        ]),
        ...mapActions("storePanel/transactions", [
            "claimCoupon",
            "getCouponVerificationCode",
            "confirmCouponVerificationCode",
            "getTransactionPreview",
        ]),

        makeTextShorter(text) {
            if (text && text.length > 10) {
                text = text.substring(0, 10) + " ...";
            }
            return text;
        },

        countDownTimer(time) {
            if (time) this.validationTime = time;
            if (this.validationTime > 0) {
                setTimeout(() => {
                    if (this.redeemDialog && !this.couponVerification) {
                        this.validationTime -= 1;
                        this.countDownTimer();
                    }
                }, 1000);
            } else if (
                !Number.isNaN(this.validationTime) &&
                this.validationTime <= 0
            ) {
                this.redeemDialog = false;
                return this.setNotification({
                    show: true,
                    type: "error",
                    text: this.translations.timeOutError[this.lang]
                });
            } else if (!this.redeemDialog || this.couponVerification) {
                this.validationTime = null;
            }
        },

        async getVerificationCode(code) {
            this.dialog = false;
            this.redeemDialog = true;
            let codeSent = await this.getCouponVerificationCode({
                code,
                user: this.transaction.user
            });
            if (codeSent) {
                this.countDownTimer(2 * 60 - 1);
            } else {
                this.setNotification({
                    show: true,
                    type: "error",
                    text: this.translations.cannotSentCodeError[this.lang]
                });
            }
        },

        async submitVerificationCode(code) {
            await this.confirmCouponVerificationCode({
                code: this.claimingCoupon.code,
                sms_verification_code: code,
                user: this.transaction.user
            });
            if (this.couponVerification) {
                this.dialog = false;
                this.setItem({ user: this.transaction.user });
                await this.getTransactionPreview(false)
                this.redeemDialog = false;

                return this.setNotification({
                    show: true,
                    type: "success",
                    text: this.translations.verificationSuccess[this.lang]
                });
            }
            this.verificationCodeAr = ["", "", "", ""];
            this.$refs["codeChar0"][0]?.focus();
            return this.setNotification({
                show: true,
                type: "error",
                text: this.translations.wrongCodeError[this.lang]
            });
        },

        setCodeChar(c, i) {
            let char = c.replace(/\D/g, "");

            if (char.length) {
                char = char[char.length - 1];

                if (i < 3) {
                    this.$refs["codeChar" + (i + 1)][0]?.focus();
                }
            }

            this.$set(this.verificationCodeAr, i, char);

            let code = this.verificationCodeAr.join("");
            if (code.length === 4) {
                this.submitVerificationCode(code);
            }
        }
    },

    mounted() {
        this.verificationCodeRules = [
            value => !!value || this.translations.required[this.lang],
            value =>
                value.length === 1 || this.translations.oneIntChar[this.lang],
            value =>
                /^[0-9]$/.test(value) || this.translations.oneIntChar[this.lang]
        ];
    },

    watch: {
        redeemDialog(val) {
            if (!val) {
                this.verificationCodeAr = ["", "", "", ""];
                this.validationTime = null;
                this.setCouponVerification(false);
            }
        }
    }
};
</script>
<style>
.verification-input * {
    text-align: center !important;
}
.verification-input input {
    font-size: 70px;
    font-weight: 550;
    min-height: 100px;
}
</style>

<style scoped>
.b-coupon {
    display: flex;
    cursor: pointer;
    border: 1px solid rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    height: 40px;
    justify-content: center;
    align-items: center;
    margin: 5px;
    padding: 5px;
}

.b-coupon--active {
    border: 2px solid #4caf50;
}
</style>
